import * as React from "react";
import type { SVGProps } from "react";
const SvgHourglass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#hourglass_svg__a)">
      <path d="M17.5 8h-11a1 1 0 0 1 0-2h11a1 1 0 1 1 0 2M17.5 18h-11a1 1 0 0 1 0-2h11a1 1 0 0 1 0 2" />
      <path d="M17 22H7a2 2 0 0 1-2-2v-2a7 7 0 1 1 14 0v2a2 2 0 0 1-2 2m-5-9a5 5 0 0 0-5 5v2h10v-2a5 5 0 0 0-5-5" />
      <path d="M12 13a7 7 0 0 1-7-7V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2a7 7 0 0 1-7 7M7 4v2a5 5 0 1 0 10 0V4z" />
    </g>
    <defs>
      <clipPath id="hourglass_svg__a">
        <path fill="#fff" d="M5 2h14v20H5z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHourglass;
